/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegratedContentAvailabilityModel } from '../../models/integrated-content-availability-model';

export interface GetIntegratedContentAvailability$Params {
  systemSerialNumber: string;
  systemMaterialNumber: number;
  modalityName: string;
}

export function getIntegratedContentAvailability(http: HttpClient, rootUrl: string, params: GetIntegratedContentAvailability$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegratedContentAvailabilityModel>> {
  const rb = new RequestBuilder(rootUrl, getIntegratedContentAvailability.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
    rb.path('modalityName', params.modalityName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegratedContentAvailabilityModel>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getIntegratedContentAvailability.PATH = '/api/systemoverview/integratedcontentavailability/{systemSerialNumber}/{systemMaterialNumber}/{modalityName}';
getIntegratedContentAvailability.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getIntegratedContentAvailability.ROOTURL = '/portal';
